import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyService, DocumentService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/contractor/services';
import { AolService } from '../../services/aol';

interface IuploadDocumentsModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
  information?: any;
}
@Component({
  selector: 'app-upload-aol-document-modal',
  templateUrl: './upload-aol-documents-modal.html',
  styleUrls: ['./upload-aol-documents-modal.scss'],
})
export class uploadAolDocumentsModalComponent implements OnInit, OnDestroy {
  @ViewChild('input') input: ElementRef;
  @ViewChild('uploadDoc') uploadDoc: ElementRef;
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;

  companyDirector: any;

  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  organizationId: string;
  currentForm: any;
  changeRequestId: string;
  heading: string;
  documentForm: FormGroup;
  selectedFile;
  fileNameArr: any = {};
  allFiles = [];
  uploadFormData: any;
  fileError;
  extraData;
  fileName: any;
  extraInformation;
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private AolService: AolService,
    private authSvc: AuthenticationService,
    private organizationSvc: OrganizationService,
    public modal: SuiModal<IuploadDocumentsModalContext, void, void>,
    private documentSvc: DocumentService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.extraData = this.modal.context.data;
    this.extraInformation = this.modal.context.information;
    console.log(this.extraInformation);
    this.documentForm = this.fb.group({
      documentName: ['', Validators.required],
      documentDescription: [''],
      document: ['', Validators.required],
      attachment: [true],
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT'],
    });
    if (this.modal.context.isEdit) {
      this.fileName = this.extraInformation.documentPath;
      this.documentForm = this.fb.group({
        documentName: [this.extraInformation.name, Validators.required],
        documentDescription: [this.extraInformation.description, Validators.required],
        document: [this.extraInformation.documentPath, Validators.required],
        attachment: [true],
        documentTypeId: ['CHANGE_REQUEST_DOCUMENT'],
      });
    }
  }

  get documents() {
    return this.documentForm.controls['documents'] as FormArray;
  }
  removeDocSegment(index: number) {
    this.documents.removeAt(index);
  }

  onFileChange(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.selectedFile = files[0];
    this.fileName = this.selectedFile['name'];
  }

  isFieldValid(field: string) {
    // return (
    //   (!this.companyDirectorForm.get(field).valid &&
    //     this.companyDirectorForm.get(field).touched) ||
    //   (this.companyDirectorForm.get(field).untouched && this.formSubmitAttempt)
    // );
    return (
      (!this.documentForm.get(field).valid &&
        this.documentForm.get(field).touched) ||
      (this.documentForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  submit() {
    this.submitDoc();
    // this.modal.context.isEdit == true
    //   ? this.updateDirector('UPDATE')
    //   : this.save();
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
  createDocument() {
    const docForm = this.fb.group({
      document: [null, Validators.required],
    });

    this.documents.push(docForm);
    this.uploadDoc.nativeElement.focus();
  }

  submitDoc() {
    this.formSubmitAttempt = false;
    if (this.documentForm.valid) {
      if (this.fileError == null) {
        delete this.documentForm.value.file;
        delete this.documentForm.value.documents;
        let data: any = this.documentForm.value;
        this.allFiles.map((file) => { });
        const formData: FormData = new FormData();
        formData.append('file', this.selectedFile, this.selectedFile.name);
        let payload: any = { formValue: data, formData: formData };
        // this.modal.approve(payload);

        this.uploadFormData = payload['formData'];
        const values = payload['formValue'];
        const jsonse = JSON.stringify(values);
        const blob = new Blob([jsonse], { type: 'application/json' });
        this.uploadFormData.append('data', blob);
        this.onUploadFile(this.uploadFormData);
      }
    } else {
      this.formSubmitAttempt = true;
      this.error = 'Please fill all required fields';
    }
  }

  onSecondUploadFile(data, id) {
    this.nullify();
    this.pending = true;
    let payload = {
      documentId: id,
      organizationAolId: this.extraData.organizationAol.organizationAolId,
      name: this.documentForm.value.documentName,
      description: this.documentForm.value.documentDescription,
    };
    this.AolService.uploadAOLDocuments({
      body: payload,
    }).subscribe(
      (res) => {
        this.pending = false;
        this.success = 'AOL document successfully uploaded';
        setTimeout(() => {
          // this.getPage(1);
          this.modal.approve(null);
        }, 2000);
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }
  onSecondUploadUpdateFile(data, id) {
    this.nullify();
    this.pending = true;
    let payload = {
      documentId: id,
      organizationAolId: this.extraData.organizationAol.organizationAolId,
      name: this.documentForm.value.documentName,
      description: this.documentForm.value.documentDescription,
    };
    this.AolService.updateDocument({
      body: payload,
      aolDocumentId: this.extraInformation.aolDocumentId,
    }).subscribe(
      (res) => {
        this.pending = false;
        this.success = 'AOL document successfully uploaded';
        setTimeout(() => {
          // this.getPage(1);
          this.modal.approve(null);
        }, 2000);
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  onUploadFile(data) {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({ organizationId: this.organizationId, body: data })
      .subscribe(
        (res: any) => {
          // this.pending = false;
          this.modal.context.isEdit
            ? this.onSecondUploadUpdateFile(this.uploadFormData, res.documentId)
            : this.onSecondUploadFile(this.uploadFormData, res.documentId);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class uploadAolDocumentsModal extends ComponentModalConfig<
  IuploadDocumentsModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    information: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(uploadAolDocumentsModalComponent, {
      title,
      data,
      information,
      isEdit,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
